/** In-memory notification; owners and portfolios remain explicit across scope changes. */
export interface PerformancePriceCorrection {
  ownerId: string
  portfolioId: string
  date: string
  kind?: 'current_quote'
}

const listeners = new Set<(correction: PerformancePriceCorrection) => void>()

export function subscribePerformancePriceCorrections(
  listener: (correction: PerformancePriceCorrection) => void
): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function notifyPerformancePriceCorrection(correction: PerformancePriceCorrection) {
  for (const listener of listeners) listener(correction)
}
